import { IAppState } from '../../../AppModulesWrapper';

import { selectOfferGuid } from '../offer';

export const selectAnalyticsFormId = (state: IAppState): string => {
  return selectOfferGuid(state);
};
